import type { AccessibilityToggleTranslations } from "./pl";

export const de: AccessibilityToggleTranslations = {
  triggerAria: "Barrierefreiheits-Panel öffnen",
  triggerTitle: "Digitale Barrierefreiheit",
  dialogAria: "Barrierefreiheits-Panel",
  panelTitle: "Digitale Barrierefreiheit",
  closeAria: "Barrierefreiheits-Panel schließen",
  fontSize: {
    heading: "Schriftgröße",
    sliderAria: "Schriftgröße",
    small: "Klein",
    large: "Groß",
  },
  contrast: {
    heading: "Kontrast",
    label: "Hoher Kontrast",
  },
  navigation: {
    heading: "Navigation",
    highlightLinks: "Links hervorheben",
  },
  shortcuts: {
    heading: "Tastenkürzel",
    jumpToContent: "Zum Inhalt springen",
    jumpToMenu: "Zum Menü springen",
  },
  reset: "Standard wiederherstellen",
};
